import React from 'react'
import { Provider } from 'mobx-react'
import type { AppProps } from 'next/app'
import { FlagsProvider } from 'react-unleash-flags'
import CustomApp from '../components/pages/CustomApp/customApp'
import { rootStore } from '../stores'
import './styles.scss'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-loading-skeleton/dist/skeleton.css'

const flagConfig = {
  extraHttpHeaders: {
    Authorization: process.env.REACT_APP_FLAGS_ACCESS_TOKEN
  }
}

const App = (props: AppProps) => {
  const { Component, pageProps, router } = props
  return (
    <Provider {...rootStore}>
      <FlagsProvider config={flagConfig}>
        <CustomApp pageProps={pageProps} Component={Component} router={router} />
      </FlagsProvider>
    </Provider>
  )
}

export default App
